export const APP_NAME = "HealthSafe ID Administrator";
export const BASIC_SEARCH = "Basic Search";
export const BASIC_SEARCH_MESSAGE =
  "Enter Username ,UUID, Email or Member/Subscriber ID";
export const BASIC_SEARCH_MESSAGE_BASELINEAGENT =
  "Enter Username, UUID or Email";
export const ADVANCED_SEARCH = "Advanced Search";
export const ADVANCED_SEARCH_MESSAGE =
  "Please fill out at least 3 fields unless searching with Subscriber or Member ID. First Name, Last Name, Date Of Birth and Last 6 of SSN are required when searching by SSN.";
// export const SEARCH_RESULTS_HEADER = ["First Name", "Last Name", "Username", "Phone", "Email", "ID Type"];
export const BASIC_SEARCH_TYPE = "basic";
export const ADVANCE_SEARCH_TYPE = "advanced";
export const MDM_SEARCH_TYPE = "mdm";
export const ACTIVITY_LOG_SEARCH_TYPE = "activityLog";

export const MDM_SEARCH = "MDM Search";
export const MDM_SEARCH_MESSAGE =
  "Search by First Name, Last Name, Date of Birth, or any combination of these fields.";
export const SESSION = "admtlsession";
export const SESSION_UUID = "admtlsessionUuid";
export const SESSION_USERNAME = "admtlsessionUserName";
export const SESSION_SUPERUSER = "SuperUser";
export const SESSION_READONLYUSER = "ReadOnlyUser";
export const SESSION_TIER1USER = "Tier1User";
export const SESSION_SUPERVISORUSER = "Supervisor";
export const SESSION_BASELINEAGENT = "BaselineAgent";
export const SESSION_USERTYPE = "userType";
export const ACCOUNT_ADMIN = "ACCOUNT_ADMIN";
export const SDK_PORTAL_LIST = "sdkPortalList";

export const MDM_ACCOUNT = "MDM Account";
export const ADD_ACCOUNT = "Add Account";
export const ACCOUNT_SECURITY = 'ACCOUNT_SECURITY';

export const ADD_ACCOUNT_ALL_FIELDS_REQUIRED =
  "All fields are required, except for UUID";

export const ADD_ELIGIBILITY = "Add/Modify Eligibility";
export const ADD_ELIGIBILITY_ALL_FIELDS_REQUIRED = "All fields are required";

export const MODIFY_ELIGIBILITY = "Modify Eligibility";
export const MODIFY_ELIGIBILITY_ALL_FIELDS_REQUIRED = "All fields are required";

export const LABEL_SAVE = "Save";
export const LABEL_UPDATE = "Update";
export const LABEL_CANCEL = "Cancel";
export const LABEL_CONFIRM = "Confirm";

export const SUPER_USER = "Super User";
export const HSID_DATA = "HealthSafe ID Backend Data";

export const OID = "OID";

export const NO_RECOVERY_OPTIONS_AVAILABLE = "NO_RECOVERY_OPTIONS_AVAILABLE";

export const LS_OTP_VERIFIED = "otpVerified";
export const LS_OTP_VERIFIED_NUMBER = "otpVerifiedNumber";
export const LS_DISABLE_IDENTITY_ATTEST_FAIL = "disableIdentity";
export const LS_BASIC_SEARCH_KEY = "basicSearch";
export const LS_ADVANCE_SEARCH_KEY = "advancedSearch";

export const AGENT_ACTIVITY_SEARCH = "Activity Search";
export const AGENT_ACTIVITY_SEARCH_MESSAGE = "";

export const PAGESIZE_ACTIVITY_LOG = 50;
export const USER_ACTIVITY_DISABLE_FLAG = false;

export const CHECK_BRIOVA_PRTL_SHORTNAME_FLAG = true;

export const LOCKED = 'LOCKED'
export const VERIFIED = 'VERIFIED'
export const RBA_OR_LDAP_LOCKED = 'Locked'
export const RBA_OR_LDAP_UNLOCKED = 'Unlocked'
export const RBA_PARTIAL_LOCKED = 'Partial Lock'

export const OPTUMLABSLOOP = "OPTUMLABSLOOP";
export const CAREADVISORCONNECT = "CAREADVISORCONNECT";
export const CAREADVISORCONNECTM = "CAREADVISORCONNECTM";

export const DISPLAY_NAME_CHANGED_PRTLS = new Set([OPTUMLABSLOOP, CAREADVISORCONNECT, CAREADVISORCONNECTM]);

export const BULK_DISABLE = "bulkDisable";
export const BULK_LOCKING = "bulkLocking";
export const BULK_DELETE = "bulkDelete";
export const BULK_DELETE_WITH_FILENAME = "bulkDeleteWithFilename";
export const BULK_EIMP_SYNC_WITH_FILENAME = "bulkEimpSyncWithFilename";
export const BULK_EIMP_SYNC = "bulkEimpSync"
export const BULK_LDAP_UNLOCK = "bulkLdapUnlock"

export const IC_OTP_GENERATION_DESC = "We’ll use the phone number below to verify identity. Choose how to send the code."
export const IC_DBIC_DESC = "Document-Based Identity Confirmation verifies your identity using a government-issued ID.";
export const IC_2STEP_DESC = "Perform 2-step authentication to verify the user's identity before proceeding."

export const AgentRoles = {
  SUPER_ADMIN_USER: "SuperAdminUser",
  SUPER_USER: "SuperUser",
  TIER1: "Support_Ops",
  READONLY: "Support_Ops_ReadOnly",
  SUPERVISOR: "Supervisor",
  BASELINE: "BaselineAgent",
  NOACCESS: "NoAccess"
}

export const ACTIVITY_LOG_SELECT_MAP = {
  "Select One": {
    name: "Select One",
    value: "",
    disabled: false,
  },
  "HSID Profile Information (Name/Email/Phone/DOB)": {
    name: "HSID Profile Information (Name/Email/Phone/DOB)",
    value: "USER_PROFILE_UPDATE",
    disabled: false,
  },
  "Enable Account": {
    name: "Enable Account",
    value: "USER_ACCOUNT_ENABLE",
    disabled: false,
  },
  "Disable Account": {
    name: "Disable Account",
    value: "USER_ACCOUNT_DISABLE",
    disabled: false,
  },
  "Add/Modify Eligibility SDK": {
    name: "Add/Modify Eligibility SDK",
    value: "ADD_ELIGIBILITY_SDK",
    disabled: false,
  },
  "Add/Modify Eligibility Non SDK": {
    name: "Add/Modify Eligibility Non SDK",
    value: "ADD_ELIGIBILITY_NON_SDK",
    disabled: false,
  },
  "Delete Eligibility": {
    name: "Delete Eligibility",
    value: "DELETE_ELIGIBILITY",
    disabled: false,
  },
  "HSID Backend Data (Name/DOB/Zip/Subscriber Id/Policy/Group #)": {
    name: "HSID Backend Data (Name/DOB/Zip/Subscriber Id/Policy/Group #)",
    value: "USER_HSID_BACKEND_DATA_UPDATE",
    disabled: false,
  },
  "Email Password Reset Link": {
    name: "Email Password Reset Link",
    value: "USER_RESET_PASSWORD",
    disabled: false,
  },
  "Email & Reset Security Questions Link": {
    name: "Email & Reset Security Questions Link",
    value: "USER_RESET_ACCT_RECOVERY",
    disabled: false,
  },
  "Email Verification": {
    name: "Email Verification",
    value: "USER_EMAIL_VERF",
    disabled: false,
  },
  "Phone Verification": {
    name: "Phone Verification",
    value: "USER_PHONE_VERF",
    disabled: false,
  },
  "Username/Password Lock (LDAP Lock)": {
    name: "Username/Password Lock (LDAP Lock)",
    value: "USER_LDAP_LOCK",
    disabled: false,
  },
  "Security Questions/Phone # Lock (RBA Lock)": {
    name: "Security Questions/Phone # Lock (RBA Lock)",
    value: "USER_RBA_LOCK",
    disabled: false,
  },
  "Delete Account": {
    name: "Delete Account",
    value: "DELETE_ACCT",
    disabled: false,
  },
  "OTP Email Generation": {
    name: "OTP Email Generation",
    value: "USER_EMAIL_OTP_GENERATION",
    disabled: false,
  },
  "OTP Email Verification": {
    name: "OTP Email Verification",
    value: "USER_EMAIL_OTP_VERIFICATION",
    disabled: false,
  },
  "OTP Phone Generation": {
    name: "OTP Phone Generation",
    value: "USER_PHONE_OTP_GENERATION",
    disabled: false,
  },
  "OTP Phone Generation - Call": {
    name: "OTP Phone Generation - Call",
    value: "USER_PHONE_OTP_GENERATION_CALL",
    disabled: false,
  },
  "OTP Phone Verification": {
    name: "OTP Phone Verification",
    value: "USER_PHONE_OTP_VERIFICATION",
    disabled: false,
  },
  "Add Account": {
    name: "Add Account",
    value: "ADD_ACCOUNT",
    disabled: false,
  },
  "Rebuild Cache SDK": {
    name: "Rebuild Cache SDK",
    value: "USER_PRTL_REBUILD_CACHE_SDK",
    disabled: false,
  },
  "Rebuild Cache Non SDK": {
    name: "Rebuild Cache Non SDK",
    value: "USER_PRTL_REBUILD_CACHE_NON_SDK",
    disabled: false,
  },
  "Delete Phone": {
    name: "Delete Phone",
    value: "USER_PHONE_DELETE",
    disabled: false,
  },
  "Bank Pre Add Eligibility Check": {
    name: "Bank Pre Add Eligibility Check",
    value: "BANK_PRE_ADD_ELIGIBILITY_CHECK",
    disabled: false,
  },
  "MyUHC Subportals Pre Add Eligibility Check": {
    name: "MyUHC Subportals Pre Add Eligibility Check",
    value: "PRE_ADD_ELIGIBILITY_CHECK",
    disabled: false,
  },
  "Add/Modify Eligibility PE": {
    name: "Add/Modify Eligibility PE",
    value: "ADD_ELIGIBILITY_PE",
    disabled: false,
  },
  "Phone Based ID Confirmation (PBIC)": {
    name: "Phone Based ID Confirmation (PBIC)",
    value: "PHONE_BASED_ID_CONFIRMATION",
    disabled: false,
  },
  "Document Based ID Confirmation (DBIC)": {
    name: "Document Based ID Confirmation (DBIC)",
    value: "DOCUMENT_BASED_ID_CONFIRMATION",
    disabled: false,
  },
  "Document Based ID Confirmation (DBIC) Polling": {
    name: "Document Based ID Confirmation (DBIC) Polling",
    value: "DOCUMENT_BASED_ID_CONFIRMATION_POLLING",
    disabled: false,
  },
  "Document Based ID Confirmation (DBIC) Idverse Status": {
    name: "Document Based ID Confirmation (DBIC) Idverse Status",
    value: "DBIC_IDVERSE_STATUS",
    disabled: false,
  },
  "DBIC Initiation": {
    name: "DBIC Initiation",
    value: "DBIC_CHALLENGE",
    disabled: false,
  },
  "DBIC Resend Link": {
    name: "DBIC Resend Link",
    value: "DBIC_RESEND_LINK",
    disabled: false,
  },
  "2-Step Attestation": {
    name: "2-Step Attestation",
    value: "TWO_STEP_ATTESTATION",
    disabled: false,
  },
  "Create Service Now Incident": {
    name: "Create Service Now Incident",
    value: "CREATE_INCIDENT",
    disabled: false,
  },
  "Basic Search": {
    name: "Basic Search",
    value: "BASIC_USER_SEARCH",
    disabled: false,
  },
  "Advanced Search": {
    name: "Advanced Search",
    value: "ADVANCED_USER_SEARCH",
    disabled: false,
  },
  "Passkey Toggle Enable": {
    name: "Passkey Toggle Enable",
    value: "TOGGLE_PASSKEY_ENABLE",
    disabled: false,
  },
  "Passkey Toggle Disable": {
    name: "Passkey Toggle Disable",
    value: "TOGGLE_PASSKEY_DISABLE",
    disabled: false,
  },
  "Passkey Delete": {
    name: "Passkey Delete",
    value: "DELETE_PASSKEY",
    disabled: false,
  },
  "Bulk Soft Delete": {
    name: "Bulk Soft Delete",
    value: "BULK_SOFT_DELETE",
    disabled: false,
  },
  "Bulk Soft Delete Initiated": {
    name: "Bulk Soft Delete Initiated",
    value: "BULK_SOFT_DELETE_INITIATED",
    disabled: false,
  },
  "Bulk Eimp Sync Initiated": {
    name: "Bulk Eimp Sync Initiated",
    value: "BULK_EIMP_SYNC_INITIATED",
    disabled: false,
  },
  "Bulk Eimp Sync": {
    name: "Bulk Eimp Sync",
    value: "BULK_EIMP_SYNC",
    disabled: false,
  },
};

export const ACTIVITY_LOG_SELECT_MAP_REVERSED = {
  USER_PROFILE_UPDATE: {
    name: "HSID Profile Information (Name/Email/Phone/DOB)",
    value: "USER_PROFILE_UPDATE",
    disabled: false,
  },
  USER_ACCOUNT_ENABLE: {
    name: "Enable Account",
    value: "USER_ACCOUNT_ENABLE",
    disabled: false,
  },
  USER_ACCOUNT_DISABLE: {
    name: "Disable Account",
    value: "USER_ACCOUNT_DISABLE",
    disabled: false,
  },
  ADD_ELIGIBILITY_SDK: {
    name: "Add/Modify Eligibility SDK",
    value: "ADD_ELIGIBILITY_SDK",
    disabled: false,
  },
  ADD_ELIGIBILITY_NON_SDK: {
    name: "Add/Modify Eligibility Non SDK",
    value: "ADD_ELIGIBILITY_NON_SDK",
    disabled: false,
  },
  DELETE_ELIGIBILITY: {
    name: "Delete Eligibility",
    value: "DELETE_ELIGIBILITY",
    disabled: false,
  },
  USER_HSID_BACKEND_DATA_UPDATE: {
    name: "HSID Backend Data (Name/DOB/Zip/Subscriber Id/Policy/Group #)",
    value: "USER_HSID_BACKEND_DATA_UPDATE",
    disabled: false,
  },
  USER_RESET_PASSWORD: {
    name: "Email Password Reset Link",
    value: "USER_RESET_PASSWORD",
    disabled: false,
  },
  USER_RESET_ACCT_RECOVERY: {
    name: "Email & Reset Security Questions Link",
    value: "USER_RESET_ACCT_RECOVERY",
    disabled: false,
  },
  USER_EMAIL_VERF: {
    name: "Email Verification",
    value: "USER_EMAIL_VERF",
    disabled: false,
  },
  USER_PHONE_VERF: {
    name: "Phone Verification",
    value: "USER_PHONE_VERF",
    disabled: false,
  },
  USER_LDAP_LOCK: {
    name: "Username/Password Lock (LDAP Lock)",
    value: "USER_LDAP_LOCK",
    disabled: false,
  },
  USER_RBA_LOCK: {
    name: "Security Questions/Phone # Lock (RBA Lock)",
    value: "USER_RBA_LOCK",
    disabled: false,
  },
  DELETE_ACCT: {
    name: "Delete Account",
    value: "DELETE_ACCT",
    disabled: false,
  },
  USER_EMAIL_OTP_GENERATION: {
    name: "OTP Email Generation",
    value: "USER_EMAIL_OTP_GENERATION",
    disabled: false,
  },
  USER_EMAIL_OTP_VERIFICATION: {
    name: "OTP Email Verification",
    value: "USER_EMAIL_OTP_VERIFICATION",
    disabled: false,
  },
  USER_PHONE_OTP_GENERATION: {
    name: "OTP Phone Generation",
    value: "USER_PHONE_OTP_GENERATION",
    disabled: false,
  },
  USER_PHONE_OTP_GENERATION_CALL: {
    name: "OTP Phone Generation - Call",
    value: "USER_PHONE_OTP_GENERATION_CALL",
    disabled: false,
  },
  USER_PHONE_OTP_VERIFICATION: {
    name: "OTP Phone Verification",
    value: "USER_PHONE_OTP_VERIFICATION",
    disabled: false,
  },
  ADD_ACCOUNT: {
    name: "Add Account",
    value: "ADD_ACCOUNT",
    disabled: false,
  },
  USER_PRTL_REBUILD_CACHE_SDK: {
    name: "Rebuild Cache SDK",
    value: "USER_PRTL_REBUILD_CACHE_SDK",
    disabled: false,
  },
  USER_PRTL_REBUILD_CACHE_NON_SDK: {
    name: "Rebuild Cache Non SDK",
    value: "USER_PRTL_REBUILD_CACHE_NON_SDK",
    disabled: false,
  },
  USER_PHONE_DELETE: {
    name: "Delete Phone",
    value: "USER_PHONE_DELETE",
    disabled: false,
  },
  BANK_PRE_ADD_ELIGIBILITY_CHECK: {
    name: "Bank Pre Add Eligibility Check",
    value: "BANK_PRE_ADD_ELIGIBILITY_CHECK",
    disabled: false,
  },
  PRE_ADD_ELIGIBILITY_CHECK: {
    name: "MyUHC Subportals Pre Add Eligibility Check",
    value: "PRE_ADD_ELIGIBILITY_CHECK",
    disabled: false,
  },
  ADD_ELIGIBILITY_PE: {
    name: "Add/Modify Eligibility PE",
    value: "ADD_ELIGIBILITY_PE",
    disabled: false,
  },
  PHONE_BASED_ID_CONFIRMATION: {
    name: "Phone Based ID Confirmation (PBIC)",
    value: "PHONE_BASED_ID_CONFIRMATION",
    disabled: false,
  },
  DOCUMENT_BASED_ID_CONFIRMATION: {
    name: "Document Based ID Confirmation (DBIC)",
    value: "DOCUMENT_BASED_ID_CONFIRMATION",
    disabled: false,
  },
  DOCUMENT_BASED_ID_CONFIRMATION_POLLING: {
    name: "Document Based ID Confirmation (DBIC) Polling",
    value: "DOCUMENT_BASED_ID_CONFIRMATION_POLLING",
    disabled: false,
  },
  DBIC_IDVERSE_STATUS: {
    name: "Document Based ID Confirmation (DBIC) Idverse Status",
    value: "DBIC_IDVERSE_STATUS",
    disabled: false,
  },
  DBIC_CHALLENGE: {
    name: "DBIC Initiation",
    value: "DBIC_CHALLENGE",
    disabled: false,
  },
  DBIC_RESEND_LINK: {
    name: "DBIC Resend Link",
    value: "DBIC_RESEND_LINK",
    disabled: false,
  },
  TWO_STEP_ATTESTATION: {
    name: "2-Step Attestation",
    value: "TWO_STEP_ATTESTATION",
    disabled: false,
  },
  CREATE_INCIDENT: {
    name: "Create Service Now Incident",
    value: "CREATE_INCIDENT",
    disabled: false,
  },
  BASIC_USER_SEARCH: {
    name: "Basic Search",
    value: "BASIC_USER_SEARCH",
     disabled: false,
    },
  TOGGLE_PASSKEY_ENABLE: {
    name: "Passkey Toggle Enable",
    value: "TOGGLE_PASSKEY_ENABLE",
     disabled: false,
    },
  TOGGLE_PASSKEY_DISABLE: {
    name: "Passkey Toggle Disable",
    value: "TOGGLE_PASSKEY_DISABLE",
     disabled: false,
    },
  DELETE_PASSKEY: {
    name: "Passkey Delete",
    value: "DELETE_PASSKEY",
    disabled: false,
  },
  BULK_SOFT_DELETE: {
    name: "Bulk Soft Delete",
    value: "BULK_SOFT_DELETE",
     disabled: false,
    },
  BULK_SOFT_DELETE_INITIATED: {
    name: "Bulk Soft Delete Initiated",
    value: "BULK_SOFT_DELETE_INITIATED",
     disabled: false,
    },
  BULK_EIMP_SYNC_INITIATED: {
      name: "Bulk Eimp Sync Initiated",
      value: "BULK_EIMP_SYNC_INITIATED",
       disabled: false,
   },
  BULK_EIMP_SYNC: {
      name: "Bulk Eimp Sync",
      value: "BULK_EIMP_SYNC",
       disabled: false,
   },
  "": {
    name: "Select One",
    value: "",
    disabled: false,
  },
};

export const TMX_FAILURE = "TMX_FAILURE";
export const TMX_FAILURE_EVENT_NUM = 100;
export const PARTIAL_SUCCESS = "PARTIAL_SUCCESS";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const INFO = "INFO";
export const EVENT_TYPE_AGENT_VALUE = "AGENT";
export const EVENT_TYPE_USER_VALUE = "USER";
export const EVENT_REGISTRATION_NAME = "Registration";
export const EVENT_FULL_STEP_UP_NAME = "Full Step Up";
export const EVENT_PHONE_BASED_ID_CONFIRMATION = "Phone Based ID Confirmation (PBIC)";

export const ACTIVITY_LOG_STATUS = [
  "Select One",
  SUCCESS,
  FAILURE,
  PARTIAL_SUCCESS,
];

export const ACTIVITY_LOG_EVENT_TYPE = ["Select One", EVENT_TYPE_AGENT_VALUE, EVENT_TYPE_USER_VALUE, "ALL"];

export const ACTIVITY_LOG_USER_EVENT_MAP = {
  "Select One": {
    name: "Select One",
    value: "",
    disabled: false,
  },
  Authenticate: {
    name: "Authenticate",
    value: "authenticate",
    disabled: false,
  },
  Registration: {
    name: EVENT_REGISTRATION_NAME,
    value: "registration",
    disabled: false,
  },
  "Registration Second Step": {
    name: "Registration Second Step",
    value: "registrationSecondStep",
    disabled: false,
  },
  "Standard SSO": {
    name: "Standard SSO",
    value: "standardsso",
    disabled: false,
  },
  "Headless SSO": {
    name: "Headless SSO",
    value: "headlesssso",
    disabled: false,
  },
  "Untrusted SSO": {
    name: "Untrusted SSO",
    value: "untrustedsso",
    disabled: false,
  },
  "New Device Login": {
    name: "New Device Login",
    value: "newDeviceEmail",
    disabled: false,
  },
  "New Device - Reset Password": {
    name: "New Device - Reset Password",
    value: "newDeviceResetPassword",
    disabled: false,
  },
  "Full Step Up":{
    name: 'Full Step Up',
    value: 'fullstepup',
    disabled: false
  }
};

export const ACTIVITY_LOG_USER_EVENT_MAP_REVERSED = {
    '':{
        name: 'Select One',
        value: '',
        disabled: false
    },
    'authenticate':{
        name: 'Authenticate',
        value: 'authenticate',
        disabled: false
    },
    'registration':{
        name: 'Registration',
        value: 'registration',
        disabled: true
    },
    'registrationSecondStep':{
        name: 'Registration Second Step',
        value: 'registrationSecondStep',
        disabled: true
    },
    'standardsso':{
        name: 'Standard SSO',
        value: 'standardsso',
        disabled: false
    },
    'headlesssso':{
        name: 'Headless SSO',
        value: 'headlesssso',
        disabled: false
    },
    'untrustedsso':{
        name: 'Untrusted SSO',
        value: 'untrustedsso',
        disabled:false
    },
    'newDeviceEmail':{
        name: 'New Device Login',
        value: 'newDeviceEmail',
        disabled: false
    },
    'newDeviceResetPassword':{
        name: 'New Device - Reset Password',
        value: 'newDeviceLoginResetPassword',
        disabled: false
    },
    "fullstepup":{
      name: 'Full Step Up',
      value: 'fullstepup',
      disabled: false
    }
}

export const ACTIVITY_LOG_SELECT_MAP_LENGTH = 25
export const ACTIVITY_LOG_USER_EVENT_MAP_LENGTH = 7
export const ALLOWED_INCIDENT_RECORD_NUMBER = 11

export const LOCALE_LIST = {
  en: { label: "English" },
  es: { label: "Spanish" },
  ht: { label: "Creole" },
  il: { label: "Ilocano" },
  kr: { label: "Korean" },
  ta: { label: "Tagalog" },
  vi: { label: "Vietnamese" },
  zh: { label: "Chinese (Mandarin)" },
};

export const EMAIL_VERIFICATION_ICON = "EMAIL_VERIFICATION_ICON";
export const PHONE_VERIFICATION_ICON = "PHONE_VERIFICATION_ICON";
export const SECONDARY_EMAIL_VERIFICATION_ICON =
  "SECONDARY_EMAIL_VERIFICATION_ICON";

export const ELIGIBILITY_CONFIRMATION = {
  displayPropMapping: {
    FirstName: { label: "First Name", fieldName: "portalFirstNm" },
    LastName: { label: "Last Name", fieldName: "portalLastNm" },
    DOB: { label: "DOB", fieldName: "portalDob" },
    GroupId: { label: "Group/Policy ID", fieldName: "portalPolicyNbr" },
    MemberId: { label: "Member Id", fieldName: "portalSpecificMemberId" },
    SubscriberId: { label: "Subscriber Id", fieldName: "portalSubscriberId" },
    Gender: { label: "Gender", fieldName: "portalGender" },
    Address_1: { label: "Address_1", fieldName: "portalAddressLine1" },
    City: { label: "City", fieldName: "portalCity" },
    State: { label: "State", fieldName: "portalState" },
    ZipCode: { label: "Zip", fieldName: "portalZip" },
    SSN: { label: "SSN", fieldName: "portalSsn" },
    EmployeeId: { label: "Employee ID", fieldName: "employeeId" },
  },

  sdkDisplayPropMapping: {
    firstName: { label: "First Name", fieldName: "portalFirstNm" },
    lastName: { label: "Last Name", fieldName: "portalLastNm" },
    dob: { label: "DOB", fieldName: "portalDob" },
    groupNumber: { label: "Group/Policy ID", fieldName: "portalPolicyNbr" },
    memberId: { label: "Member Id", fieldName: "portalSpecificMemberId" },
    subscriberId: { label: "Subscriber Id", fieldName: "portalSubscriberId" },
    gender: { label: "Gender", fieldName: "portalGender" },
    address1: { label: "Address_1", fieldName: "portalAddressLine1" },
    city: { label: "City", fieldName: "portalCity" },
    state: { label: "State", fieldName: "portalState" },
    zipCode: { label: "Zip", fieldName: "portalZip" },
    ssn: { label: "SSN", fieldName: "portalSsn" },
    employeeId: { label: "Employee ID", fieldName: "employeeId" },
  },
};

//To enable/disable fetching of SDK portals for all flows
export const SDK_ENABLE = process.env.REACT_APP_SDK_ENABLE
  ? process.env.REACT_APP_SDK_ENABLE === "true"
  : true;
export const BRIOVA_ELIGIBILITY_ERROR = "BRIOVA_ELIGIBILITY_ERROR";
export const MEDICAL_RECORD_NUMBER = "Medical Record Number";

// To enable/disable auto complete portal dropdown in Admin tool screens
export const AUTO_COMPLETE_SELECT_ENABLE = process.env.REACT_AUTO_COMPLETE_SELECT ? process.env.REACT_AUTO_COMPLETE_SELECT === 'true' : true;

// To enable/disable quick links to external sites in the member portal eligibility table
export const QUICK_LINKS_ENABLE = process.env.QUICK_LINKS_ENABLE ? process.env.QUICK_LINKS_ENABLE === 'true' : true;

//Indicates time in milliseconds after which warning popup would be displayed
export const TIMEOUT_PERIOD = 840000; //14 minutes

//Indicates time in milliseconds after which warning popup would close and user would be logged out
export const WARNING_TIMEOUT_PERIOD = 60000; //1 minute

//To enable/disable toggle button for switching super user and tier 1 user
export const SUPER_USER_TOGGLE_DROPDOWN_ENABLED = true;
export const PRIVILEGED_MSID_WHITELIST = [
  "Apost07",
  "vsing176",
  "klakhara",
  "mpulluru",
  "bsures14",
  "vponnad",
  "shalahar",
  "swasti",
  "vvishwa7",
  "bkuma320",
  "abisht1",
  "jgunbil",
  "ppraka36",
  "vgupt140",
  "mpete12",
  "snegi6",
  "srizvi5",
  "sambat15",
  "dbrahma1",
  "jgagnon7","jcapsas","jgood10","apost7","wransom1","vwold2","asriv130","arosen7","dkimbro4","dproska",
  "sreddyb2","gkuma460","mansar48","rkanihal","mchakr28","ychoudh4","asing173",
  "aacharj4","sjhanwer","cprabha2","cgupta46","ssin1256","mfatima1","rsivaku3"
];
export const DEPLOYMENT_ENV_WHITELIST = [
  "development",
  "developmentoso",
  "stageoso",
  "testoso",
];
export const NON_ONBOARDED_CYC_PORTALS = [];
export const DISABLE_BASE_ACCOUNT = "DISABLE_BASE_ACCOUNT";
export const PARTIAL_LOCK_WARN =
    "The account is not fully unlocked. To completely unlock the account, Please add the phone number and country code then press - Complete/Send Notification";
export const FULL_LOCK_WARN =
  "Agent must toggle this button to unlock the members account.";
export const BASE_ACCOUNT_SECURITY_ERROR_MESSAGE =
  "This functionality is not applicable for Base Account users.";
export const BASE_LINE_AGENT_NOT_ALLOWED_MESSAGE = 
"Please contact a Healthsafe ID Specialist for further guidance at 1-866-276-0683";
export const BASE_LINE_AGENTS_RESTRICT_DISABLE = 
"This account has been restricted for security purposes. Please contact a Healthsafe ID Specialist for further guidance at 1-866-276-0683";
export const BASE_LINE_AGENTS_RESTRICT_DELETE = 
"This function is not permitted. Please contact a Healthsafe ID Specialist for further guidance at 1-866-276-0683";
export const OTHER_REASON = "Other";

export const LIST_OF_ACCOUNT_DISABLE_REASONS = [
  "Caller cannot confirm identity and/or pass OTP requirements.",
  "Caller received notification which caused alarm.",
  "Employee Error has caused a concern.",
  "This member is being impacted from another incident.",
  "This member’s policy seems to be merged/co-mingled.",
  "This member’s HSID profile lists another member’s information.",
  "Caller claims, they did not create this HealthSafe ID.",
  "Member is logged in and seeing someone else’s information.",
  'Member attempted to register and got the "We found your username” error code but the username presented is not recognized by the caller.',
  OTHER_REASON,
];

export const portal_with_portal_at_name_end = ["Care Advisor Connect Portal", "HPN / SHL Portal"];

export const DISABLE_REASONS = "DISABLE_REASONS";
export const DISABLE_SUCCESS = "DISABLE_SUCCESS";
export const DISABLE_SUCCESS_MESSAGE =
  "This account has been successfully disabled. Please escalate for further assistance.";

  export const SERVICENOW_REASONS = "SERVICE_NOWReasonList";

export const QUICK_VIEW_FIELD_IDS = {
  firstName: "First Name",
  lastName: "Last Name",
  idType: "ID Type",
  uuid: "UUID",
  userName: "User Name",
  memberId: "Member ID/Subscriber ID",
  hsidCreatedDate: "HSID Created Date",
  dob: "Date of Birth",
  zip: "Zip Code",
  recoveryMethod: "Recovery Method",
  lastLoginDate: "HSID Last Login Date",
  pwdResetDate: "HSID Password Reset Date",
  hsidRegistrationPortal: "HSID Registration Portal",
};

export const QUICK_VIEW_MODES = {
  //All the ids mentioned in these mode will not show up in quick view, please use them cautiuosly
  READ_ONLY_VIEW: [
    QUICK_VIEW_FIELD_IDS.lastLoginDate,
    QUICK_VIEW_FIELD_IDS.pwdResetDate,
  ],
  BASIC_ACCOUNT_VIEW: [
    QUICK_VIEW_FIELD_IDS.firstName,
    QUICK_VIEW_FIELD_IDS.lastName,
    QUICK_VIEW_FIELD_IDS.memberId,
    QUICK_VIEW_FIELD_IDS.hsidCreatedDate,
    QUICK_VIEW_FIELD_IDS.dob,
    QUICK_VIEW_FIELD_IDS.lastLoginDate,
    QUICK_VIEW_FIELD_IDS.hsidRegistrationPortal,
    QUICK_VIEW_FIELD_IDS.zip,
  ],
};

export const HSID_DELETED = "HSID_DELETED";
export const HSID_BASE = "HSID_BASE";
export const HSID_NULL = "HSID_NULL";
export const HSID_MEMBER = "HSID_MEMBER";
export const HSID_PARTIAL_REGISTRATION = "HSID_PARTIAL_REGISTRATION";
export const HSID_HEADLESS = "HSID_HEADLESS";
export const HSID_PERSONAL_REPRESENTATIVE = "HSID_PERSONAL_REPRESENTATIVE";

export const ID_TYPE_NEW = {
  HSID_DELETED: "HSID-Deleted",
  HSID_BASE: "HSID-Base",
  HSID_NULL: "HSID-Null",
  HSID_MEMBER: "HSID-Member",
  HSID_PARTIAL_REGISTRATION: "HSID-Partial Registration",
  HSID_HEADLESS: "HSID-Headless",
  HSID_PERSONAL_REPRESENTATIVE: "HSID-Personal Representative",
};

export const ID_TYPES_REVERSED = {
  "HSID-Deleted": HSID_DELETED,
  "HSID-Base": HSID_BASE,
  "HSID-Null": HSID_NULL,
  "HSID-Member": HSID_MEMBER,
  "HSID-Partial Registration": HSID_PARTIAL_REGISTRATION,
  "HSID-Headless": HSID_HEADLESS,
  "HSID-Personal Representative": HSID_PERSONAL_REPRESENTATIVE,
};

export const MEMBER_ACCOUNT_MODES = {
    //All the ids mentioned in these mode will not show up in left section of member account, please use them cautiuosly 
    BASE_ACCOUNT_MODE :[
        "firstName",
        "lastName",
        "DOB",
        "ZipCode"
    ],
    DEFAULT_MODE :[],
    REMAINING_FIELDS: [
        "email",
        "emailVerification",
        "secondaryEmail",
        "deleteSecondaryEmail",
        "secondaryEmailVerification",
        "phone",
        "deletePhone",
        "phoneVerification",
        "internationalCode",
        "phoneType"
    ]

}

export const NOACCESS_ERROR_MESSAGE = "You don't have access to HSID Admin Tool!";
export const SPECIAL_CHARACTER = ["<",'"',"+",":",";","=","\\","*","&","(",")","#",",",];
export const PORTAL_DISPLAY_NAME_MAP = {"CAP":"BANK", "BRIOVA":"OSP-RX", "OSP":"OSP-RX", "LCP":"OCPP", "FH":"UMR", "CAREADVISORCONNECT":"Care Advisor Connect Portal", "CAREADVISORCONNECTM":"Care Advisor Connect Mobile", "SIERRAHPN": "HPN / SHL Portal", "SIERRAHPNSHL" : "HPN / SHL Mobile",
"LOYALTY":"Rally Engage (Loyalty)"
};

export const HIGHLIGHTED_VALUES_IN_PORTAL_DROPDOWN = [
  "MYUHC",
  "SECURE_OPTUMFINANCIAL",
  "CAP",
  "RX",
];
export const USER_ENABLED_BY_ADMIN = "USER_ENABLED_BY_ADMIN";

export const COPY_SUCCESS_MESSAGE = "Successfully Copied!";
export const COPY_FAILURE_MESSAGE = "Unable to Copy";
export const USERNAME_NOT_AVAILABLE_ERROR_MESSAGE =
  "Username is not available, please have member select a different username";

export const VIEW_POLICY_LINK = "viewPolicyLink";
export const MIMIC_TOOL_LINK = "mimicToolLink";

export const PORTAL_MAP = {
  MYUHC: "MYUHC",
  EXCHANGE: "EXCHANGE",
  LAWW: "LAWW",
  UHCMEMBERHUB: "UHCMEMBERHUB",
  PHSOPTUM: "PHSOPTUM",
  PHS: "PHS",
  RALLYDHP: "RALLYDHP",
  YTTH: "YTTH",
  YTTH2: "YTTH2",
  RXAARP: "RXAARP",
  AHC: "AHC",
  BAZ: "BAZ",
  BCBSSC: "BCBSSC",
  AHA: "AHA",
  AMERIHEALTH: "AMERIHEALTH",
  IBX: "IBX",
  OSP_RX: "OSP-RX",
  RX: "RX",
  PAI: "PAI",
  PHP: "PHP",
  SRVU: "SRVU",
  TCC: "TCC",
  OCPP: "OCPP",
  COMMUNITYPLAN: "COMMUNITYPLAN",
  AARP: "AARP",
  PCP: "PCP",
  UHC: "UHC",
  UCARD: "UCARD",
  RETIREE: "RETIREE",
  PRUDENTIAL_CONNECT_YOURCARE: "PRUDENTIAL_CONNECTYOURCARE",
  EXTERNAL_OPTUMFINANCIAL: "EXTERNAL_OPTUMFINANCIAL",
  ASSETHEALTH_OPTUMFINANCIAL: "ASSETHEALTH_OPTUMFINANCIAL",
  FACEBOOK_OPTUMFINANCIAL: "FACEBOOK_OPTUMFINANCIAL",
  FEDEX_OPTUMFINANCIAL: "FEDEX_OPTUMFINANCIAL",
  FLCB_OPTUMFINANCIAL: "FLCB_OPTUMFINANCIAL",
  GEISINGER_OPTUMFINANCIAL: "GEISINGER_OPTUMFINANCIAL",
  GISI_OPTUMFINANCIAL: "GISI_OPTUMFINANCIAL",
  JUSTWORKS_OPTUMFINANCIAL: "JUSTWORKS_OPTUMFINANCIAL",
  KFHPMAS_OPTUMFINANCIAL: "KFHPMAS_OPTUMFINANCIAL",
  MARINCOUNTY_OPTUMFINANCIAL: "MARINCOUNTY_OPTUMFINANCIAL",
  MTB_OPTUMFINANCIAL: "MTB_OPTUMFINANCIAL",
  SECURE_OPTUMFINANCIAL: "SECURE_OPTUMFINANCIAL",
  PARTNER_OPTUMFINANCIAL: "PARTNER_OPTUMFINANCIAL",
  RSFH_OPTUMFINANCIAL: "RSFH_OPTUMFINANCIAL",
  SIG_OPTUMFINANCIAL: "SIG_OPTUMFINANCIAL",
  UOPX_OPTUMFINANCIAL: "UOPX_OPTUMFINANCIAL",
  ZIONS_OPTUMFINANCIAL: "ZIONS_OPTUMFINANCIAL",
  WWW_FUNDINGLIFEWISEWA: "WWW_FUNDINGLIFEWISEWA",
  WWW_FUNDINGPREMERAAK: "WWW_FUNDINGPREMERAAK",
  WWW_FUNDINGPREMERAWA: "WWW_FUNDINGPREMERAWA",
  PRUDENTIAL_CONNECTYOURCARE: "PRUDENTIAL_CONNECTYOURCARE",
  LEVEL2: "LEVEL2",
  BANK: "BANK",
  CAPDISNEY: "CAPDISNEY",
  EMPOWER: "EMPOWER",
  CAPAARP: "CAPAARP",
  CAPMYUHC: "CAPMYUHC",
  CAPOXFORD: "CAPOXFORD",
  CAPUHCHA: "CAPUHCHA",
  CAPUHCRA: "CAPUHCRA",
  SS: "SS",
  FHG: "FHG",
  FH: "FH",
  ALLSAVERS: "ALLSAVERS",
  BSCA: "BSCA",
  MYOPTUM: "MYOPTUM",
  MOM: "MOM",
  OVC: "OVC",
  OVCAPP: "OVCAPP",
  SOLSTICE: "SOLSTICE",
  LINCOLNFINANCIAL: "LINCOLNFINANCIAL",
  MEDIGOLD: "MEDIGOLD",
  MORGANWHITE: "MORGANWHITE",
  FEDVIP: "FEDVIP",
  GEHUB: "GEHUB",
  UMR_BOB: "UMR-BOB",
  HARVARDPILGRIM: "HARVARDPILGRIM",
  HEALTHNET: "HEALTHNET",
  GENYOU: "GENYOU",
  BRIOVA: "BRIOVA",
  LCP: "LCP",
  CAP: "CAP",
  SIERRAHPN: "SIERRAHPN",
  SIERRAHPNSHL: "SIERRAHPNSHL"
};

export const VIEW_POLICY_EXTERNAL_LINKS = [
  "#",
  "https://cdbportalv2.uhc.com/#/home",
  "https://rxnavigator.optum.com/GTConnect/UnifiedAcceptor/OptumDesktop.Main?novcc=1",
  "https://odxui.optum.com/",
  "https://maestrogo.uhc.com/prweb/PRAuth/SSO",
  "https://callcenter.connectyourcare.com/",
  "https://admin-lvl2.uhc.com/",
  "http://ohbweb01/FtpsManager/Search.aspx",
  "https://admin.umr.com/",
  "https://rxnavigator.optum.com/GTConnect/UnifiedAcceptor/OptumDesktop.Main?novcc=1",//OSP-RX,
  "https://admin.umr.com/",
  "https://admin.umr.com/",
  "https://myapps.sierrahealth.com/Citrix/StoreWeb/"
];

export const MIMIC_EXTERNAL_LINKS = [
  "#",
  "https://admin-allsavers.optum.com/",
  "https://www.yourdentalplan.com/member/presuaction.do",
  "https://www.myuhc.com/member/presuaction.do",
  "https://admin-lvl2.uhc.com/",
  "https://laww-admin-ohbs-msapps-prod.origin-elr-core.optum.com/login",
  "https://generic.uhc.com/memberonlineaccount#/memberAuthLogin",
  "https://cap-su.optumbank.com/EAP/Portlets/superUserSearch.jsf",
  "https://www.myuhc.com/member/presuaction.do",
  "https://www.myuhc.com/member/presuaction.do",
  "http://aysadministration.sierrahealth.com/"
];

export const timeZones = [
  { label: "(GMT-12:00) International Date Line West", value: "Etc/GMT+12" },
  { label: "(GMT-11:00) Midway Island, Samoa", value: "Pacific/Midway" },
  { label: "(GMT-10:00) Hawaii", value: "Pacific/Honolulu" },
  { label: "(GMT-09:00) Alaska", value: "US/Alaska" },
  {
    label: "(GMT-08:00) Pacific Time (US & Canada)",
    value: "America/Los_Angeles",
  },
  { label: "(GMT-08:00) Tijuana, Baja California", value: "America/Tijuana" },
  { label: "(GMT-07:00) Arizona", value: "US/Arizona" },
  {
    label: "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
    value: "America/Chihuahua",
  },
  { label: "(GMT-07:00) Mountain Time (US & Canada)", value: "US/Mountain" },
  { label: "(GMT-06:00) Central America", value: "America/Managua" },
  { label: "(GMT-06:00) Central Time (US & Canada)", value: "US/Central" },
  {
    label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
    value: "America/Mexico_City",
  },
  { label: "(GMT-06:00) Saskatchewan", value: "Canada/Saskatchewan" },
  {
    label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
    value: "America/Bogota",
  },
  { label: "(GMT-05:00) Eastern Time (US & Canada)", value: "US/Eastern" },
  { label: "(GMT-05:00) Indiana (East)", value: "US/East-Indiana" },
  { label: "(GMT-04:00) Atlantic Time (Canada)", value: "Canada/Atlantic" },
  { label: "(GMT-04:00) Caracas, La Paz", value: "America/Caracas" },
  { label: "(GMT-04:00) Manaus", value: "America/Manaus" },
  { label: "(GMT-04:00) Santiago", value: "America/Santiago" },
  { label: "(GMT-03:30) Newfoundland", value: "Canada/Newfoundland" },
  { label: "(GMT-03:00) Brasilia", value: "America/Sao_Paulo" },
  {
    label: "(GMT-03:00) Buenos Aires, Georgetown",
    value: "America/Argentina/Buenos_Aires",
  },
  { label: "(GMT-03:00) Greenland", value: "America/Godthab" },
  { label: "(GMT-03:00) Montevideo", value: "America/Montevideo" },
  { label: "(GMT-02:00) Mid-Atlantic", value: "America/Noronha" },
  { label: "(GMT-01:00) Cape Verde Is.", value: "Atlantic/Cape_Verde" },
  { label: "(GMT-01:00) Azores", value: "Atlantic/Azores" },
  {
    label: "(GMT+00:00) Casablanca, Monrovia, Reykjavik",
    value: "Africa/Casablanca",
  },
  {
    label:
      "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
    value: "Etc/Greenwich",
  },
  {
    label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    value: "Europe/Amsterdam",
  },
  {
    label: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    value: "Europe/Belgrade",
  },
  {
    label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
    value: "Europe/Brussels",
  },
  {
    label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    value: "Europe/Sarajevo",
  },
  { label: "(GMT+01:00) West Central Africa", value: "Africa/Lagos" },
  { label: "(GMT+02:00) Amman", value: "Asia/Amman" },
  { label: "(GMT+02:00) Athens, Bucharest, Istanbul", value: "Europe/Athens" },
  { label: "(GMT+02:00) Beirut", value: "Asia/Beirut" },
  { label: "(GMT+02:00) Cairo", value: "Africa/Cairo" },
  { label: "(GMT+02:00) Harare, Pretoria", value: "Africa/Harare" },
  {
    label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    value: "Europe/Helsinki",
  },
  { label: "(GMT+02:00) Jerusalem", value: "Asia/Jerusalem" },
  { label: "(GMT+02:00) Minsk", value: "Europe/Minsk" },
  { label: "(GMT+02:00) Windhoek", value: "Africa/Windhoek" },
  { label: "(GMT+03:00) Kuwait, Riyadh, Baghdad", value: "Asia/Kuwait" },
  {
    label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
    value: "Europe/Moscow",
  },
  { label: "(GMT+03:00) Nairobi", value: "Africa/Nairobi" },
  { label: "(GMT+03:00) Tbilisi", value: "Asia/Tbilisi" },
  { label: "(GMT+03:30) Tehran", value: "Asia/Tehran" },
  { label: "(GMT+04:00) Abu Dhabi, Muscat", value: "Asia/Muscat" },
  { label: "(GMT+04:00) Baku", value: "Asia/Baku" },
  { label: "(GMT+04:00) Yerevan", value: "Asia/Yerevan" },
  { label: "(GMT+04:30) Kabul", value: "Asia/Kabul" },
  { label: "(GMT+05:00) Yekaterinburg", value: "Asia/Yekaterinburg" },
  { label: "(GMT+05:00) Islamabad, Karachi, Tashkent", value: "Asia/Karachi" },
  {
    label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    value: "Asia/Calcutta",
  },
  { label: "(GMT+05:30) Sri Jayawardenapura", value: "Asia/Calcutta" },
  { label: "(GMT+05:45) Kathmandu", value: "Asia/Katmandu" },
  { label: "(GMT+06:00) Almaty, Novosibirsk", value: "Asia/Almaty" },
  { label: "(GMT+06:00) Astana, Dhaka", value: "Asia/Dhaka" },
  { label: "(GMT+06:30) Yangon (Rangoon)", value: "Asia/Rangoon" },
  { label: "(GMT+07:00) Bangkok, Hanoi, Jakarta", value: "Asia/Bangkok" },
  { label: "(GMT+07:00) Krasnoyarsk", value: "Asia/Krasnoyarsk" },
  {
    label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    value: "Asia/Hong_Kong",
  },
  { label: "(GMT+08:00) Kuala Lumpur, Singapore", value: "Asia/Kuala_Lumpur" },
  { label: "(GMT+08:00) Irkutsk, Ulaan Bataar", value: "Asia/Irkutsk" },
  { label: "(GMT+08:00) Perth", value: "Australia/Perth" },
  { label: "(GMT+08:00) Taipei", value: "Asia/Taipei" },
  { label: "(GMT+09:00) Osaka, Sapporo, Tokyo", value: "Asia/Tokyo" },
  { label: "(GMT+09:00) Seoul", value: "Asia/Seoul" },
  { label: "(GMT+09:00) Yakutsk", value: "Asia/Yakutsk" },
  { label: "(GMT+09:30) Adelaide", value: "Australia/Adelaide" },
  { label: "(GMT+09:30) Darwin", value: "Australia/Darwin" },
  { label: "(GMT+10:00) Brisbane", value: "Australia/Brisbane" },
  {
    label: "(GMT+10:00) Canberra, Melbourne, Sydney",
    value: "Australia/Canberra",
  },
  { label: "(GMT+10:00) Hobart", value: "Australia/Hobart" },
  { label: "(GMT+10:00) Guam, Port Moresby", value: "Pacific/Guam" },
  { label: "(GMT+10:00) Vladivostok", value: "Asia/Vladivostok" },
  {
    label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
    value: "Asia/Magadan",
  },
  { label: "(GMT+12:00) Auckland, Wellington", value: "Pacific/Auckland" },
  { label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.", value: "Pacific/Fiji" },
  { label: "(GMT+13:00) Nuku'alofa", value: "Pacific/Tongatapu" },
];

export const INCIDENT_FORM_ENABLED = false;
// export const INCIDENT_FORM_ENABLED = process.env.REACT_APP_INCIDENT_FORM_ENABLED ? process.env.REACT_APP_INCIDENT_FORM_ENABLED === "true" : true;

export const REPORTER_INCIDENT = "REPORTER_INCIDENT";
export const BASICS_INCIDENT = "BASICS_INCIDENT";
export const DESCRIPTION_INCIDENT = "DESCRIPTION_INCIDENT";
export const IMPACTED_MEMBER_INCIDENT = "IMPACTED_MEMBER_INCIDENT";
export const CALLER_DETAILS_INCIDENT = "CALLER_DETAILS_INCIDENT";

export const reasonComponents = {
  "Caller cannot pass two step authentication requirements for identity purposes" : [
    REPORTER_INCIDENT,
    BASICS_INCIDENT,
    DESCRIPTION_INCIDENT,
    IMPACTED_MEMBER_INCIDENT,
    CALLER_DETAILS_INCIDENT
  ]
};

export const REPORT = "Reports";
export const SERVICE_NOW = "Service now";
export const CREATE_SERVICE_NOW = "Create Incident";
export const EDIT_SERVICE_NOW = "Edit Incident";
export const SEARCH_SERVICE_NOW = "Search Incident";
export const DETAILS_SERVICE_NOW = "Incident Details";
export const SERVICE_NOW_BASE_URLS_FOR_INCIDENT_FORM = [
  "https://optumstage.service-now.com/nav_to.do?uri=%2Fincident.do%3Fsys_id=",
  "https://optum.service-now.com/nav_to.do?uri=%2Fincident.do%3Fsys_id="
]

export const UTC_NAME = " (UTC)";

export const greyAreaCSS = {
  backgroundColor: `rgba(95, 95, 95, 0.7)`,
  position: "absolute",
  borderRadius: "8px",
  zIndex: "1",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
}

export const identifiers = new Set(["ssn", "memberId", "groupNumber", "employeeId", "employerAssignedId", "healthPlanMemberId"]);
export const portalsWithNoIdentification = {
  "UHCHEARINGHM": "Member ID", 
  "UHCHEARINGMEMBER": "Medicare Number/Member ID", 
  "AARPHEARINGMEMBER": "Medicare Number/Member ID"
};